import React, {
  useState, Fragment, useEffect,
} from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import './style.scss';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import H3FormInput from '@Uilib/h3FormInput';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import PaymentModeActions from '../../../../../actions/configurations/paymentModeAction';
import PRZSelect from '../../../../Common/UI/PRZSelect';
/**
 * PaymentTermForm component
 *
 * @param file
 */
const { Option } = Select;
const PaymentModeForm = ({
  selectedPaymentMode, updatePaymentModeLoading, createPaymentModeLoading, createPaymentMode, updatePaymentMode, callback,

}) => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [accountName, setAccountName] = useState(null);
  const [accountNumber, setAccountNumber] = useState(null);
  const [ifscCode, setIfscCode] = useState(null);
  const [creditCardNumber, setCreditCardNumber] = useState(null);
  const [remarks, setRemarks] = useState(null);
  const [accountType, setAccountType] = useState(null);
  const [bankAccountName, setBankAccountName] = useState(null);

  useEffect(() => {
    if (selectedPaymentMode) {
      setAccountName(selectedPaymentMode?.account_name);
      setAccountType(selectedPaymentMode?.account_type);
      setBankAccountName(selectedPaymentMode?.bank_name);
      setAccountNumber(selectedPaymentMode?.bank_account_number);
      setIfscCode(selectedPaymentMode?.bank_ifsc);
      setCreditCardNumber(selectedPaymentMode?.credit_card_number);
      setRemarks(selectedPaymentMode?.remarks);
    }
  }, [selectedPaymentMode]);

  const CreatePaymentAccount = () => {
    setFormSubmitted(true);
    const payload = {
      account_name: accountName,
      account_type: accountType,
      bank_name: accountType === 'BANK_TRANSFER' ? bankAccountName : null,
      bank_account_number: accountType === 'BANK_TRANSFER' ? accountNumber : null,
      bank_ifsc: accountType === 'BANK_TRANSFER' ? ifscCode : null,
      credit_card_number: accountType === 'CREDIT_CARD' ? creditCardNumber : null,
      remarks,
    };
    if (accountName.length > 0 && accountType) {
      if (creditCardNumber && creditCardNumber.length === 16) {
        createPaymentMode(payload, () => {
          setAccountName(null);
          setAccountType(null);
          setBankAccountName(null);
          setAccountNumber(null);
          setIfscCode(null);
          setCreditCardNumber(null);
          setRemarks(null);
          setFormSubmitted(false);
          callback();
        });
      } else if (!creditCardNumber && accountType !== 'CREDIT_CARD') {
        createPaymentMode(payload, () => {
          setAccountName(null);
          setAccountType(null);
          setBankAccountName(null);
          setAccountNumber(null);
          setIfscCode(null);
          setCreditCardNumber(null);
          setRemarks(null);
          setFormSubmitted(false);
          callback();
        });
      }
    }
  };

  const UpdatePaymentAccount = () => {
    setFormSubmitted(true);
    const payload = {
      account_name: accountName,
      account_type: accountType,
      bank_name: accountType === 'BANK_TRANSFER' ? bankAccountName : null,
      bank_account_number: accountType === 'BANK_TRANSFER' ? accountNumber : null,
      bank_ifsc: accountType === 'BANK_TRANSFER' ? ifscCode : null,
      credit_card_number: accountType === 'CREDIT_CARD' ? creditCardNumber : null,
      remarks,
      account_id: selectedPaymentMode?.account_id,
    };
    if (selectedPaymentMode) {
      updatePaymentMode(payload, () => {
        setAccountName(null);
        setAccountType(null);
        setBankAccountName(null);
        setAccountNumber(null);
        setIfscCode(null);
        setCreditCardNumber(null);
        setRemarks(null);
        setFormSubmitted(false);
        callback();
      });
    }
  };

  const paymentModeOptions = [
    { label: 'Cash', value: 'CASH' },
    { label: 'Bank Transfer', value: 'BANK_TRANSFER' },
    { label: 'Credit Card', value: 'CREDIT_CARD' },
    { label: 'Other', value: 'OTHER' },
  ];  

  return (
    <Fragment>
      <div className="ant-row">
        <div className="ant-col-md-24">
          <H3FormInput
            type="text"
            containerClassName="orgInputContainer create-category-input"
            labelClassName="orgFormLabel"
            inputClassName="orgFormInput"
            onChange={(event) => {
              setAccountName(event.target.value);
            }}
            value={accountName}
            label="Account Name"
            maxlength="50"
            required
            disabled={updatePaymentModeLoading || createPaymentModeLoading}
            loading={updatePaymentModeLoading || createPaymentModeLoading}
          />
          {formSubmitted && !accountName && <div className="formError">*Please Fill the Account Name</div>}
        </div>
        <div className="ant-col-md-24">
          <div className="orgInputContainer">
            <label className="orgFormLabel">
              Account Type
              <span style={{ color: 'red', marginLeft: '5px' }}>*</span>
            </label>
            <PRZSelect
              filterOption={false}
              onChange={(value) => setAccountType(value)}
              value={accountType}
              disabled={updatePaymentModeLoading || createPaymentModeLoading}
              loading={updatePaymentModeLoading || createPaymentModeLoading}
              placeholder="Select Account Type"
              className="customSelect"
              options={paymentModeOptions}
              showError={!accountType && formSubmitted}
              errorName={"Account Type"}
              errorClassName={"formError"}
            />
            {/* {!accountType && formSubmitted && <div className="formError">*Please select Account Type</div>} */}
          </div>
        </div>
        {accountType === 'BANK_TRANSFER' && (
          <div className="ant-col-md-24">
            <div>
              <H3FormInput
                type="text"
                containerClassName="orgInputContainer create-category-input"
                labelClassName="orgFormLabel"
                inputClassName="orgFormInput"
                onChange={(event) => {
                  setBankAccountName(event.target.value);
                }}
                value={bankAccountName}
                label="Bank Account Name"
                maxlength="100"
                disabled={updatePaymentModeLoading || createPaymentModeLoading}
                loading={updatePaymentModeLoading || createPaymentModeLoading}
              />
            </div>
            <div>
              <H3FormInput
                type="text"
                containerClassName="orgInputContainer create-category-input"
                labelClassName="orgFormLabel"
                inputClassName="orgFormInput"
                onChange={(event) => {
                  setAccountNumber(event.target.value);
                }}
                value={accountNumber}
                label="Bank Account Number"
                maxlength="16"
                disabled={updatePaymentModeLoading || createPaymentModeLoading}
                loading={updatePaymentModeLoading || createPaymentModeLoading}
              />
            </div>

            <div>
              <H3FormInput
                type="text"
                containerClassName="orgInputContainer create-category-input"
                labelClassName="orgFormLabel"
                inputClassName="orgFormInput"
                onChange={(event) => {
                  setIfscCode(event.target.value);
                }}
                value={ifscCode}
                label="Bank IFSC Code"
                maxlength="10"
                disabled={updatePaymentModeLoading || createPaymentModeLoading}
                loading={updatePaymentModeLoading || createPaymentModeLoading}
              />
            </div>
          </div>
        )}

        { accountType === 'CREDIT_CARD' && (
          <React.Fragment>
            <div className="ant-col-md-24">
              <H3FormInput
                type="text"
                containerClassName="orgInputContainer create-category-input"
                labelClassName="orgFormLabel"
                inputClassName="orgFormInput"
                onChange={(event) => {
                  setCreditCardNumber(event.target.value);
                }}
                value={creditCardNumber}
                label="Credit Card Number"
                maxlength="16"
                disabled={updatePaymentModeLoading || createPaymentModeLoading}
                loading={updatePaymentModeLoading || createPaymentModeLoading}
              />
            </div>
            {formSubmitted && creditCardNumber?.length !== 16 && <div className="formError">*Please Fill the Credit Card Number Properly</div>}
          </React.Fragment>
        )}

        <div className="ant-col-md-24">
          <label className="orgFormLabel">
            Remarks
          </label>
          <TextArea
            rows={2}
            placeholder="Add your remark here"
            className="customTextArea"
            onChange={(event) => {
              setRemarks(event.target.value);
            }}
            value={remarks}
            disabled={updatePaymentModeLoading || createPaymentModeLoading}
            loading={updatePaymentModeLoading || createPaymentModeLoading}
          />
        </div>
      </div>
      <div className="custom-drawer__footer">
        <div className="ant-col-md-6">
          <H3Button
            buttonType={defaultButtonTypes.BLUE_ROUNDED}
            text={selectedPaymentMode ? 'Update Account' : 'Add Account'}
            onClick={() => (selectedPaymentMode ? UpdatePaymentAccount() : CreatePaymentAccount())}
            isLoading={createPaymentModeLoading || updatePaymentModeLoading}
            disabled={updatePaymentModeLoading || createPaymentModeLoading}
            style={{
              width: '180px',
              borderRadius: '5px',
              padding: '7px 0px',
              marginLeft: '0',
            }}
          />
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, PaymentModeReducers }) => ({
  user: UserReducers.user,
  createPaymentModeLoading: PaymentModeReducers.createPaymentModeLoading,
  updatePaymentModeLoading: PaymentModeReducers.updatePaymentModeLoading,
});

const mapDispatchToProps = (dispatch) => ({
  createPaymentMode: (payload, callback) => dispatch(PaymentModeActions.createPaymentMode(payload, callback)),
  updatePaymentMode: (payload, callback) => dispatch(PaymentModeActions.updatePaymentMode(payload, callback)),
});

PaymentModeForm.propTypes = {
  createPaymentModeLoading: PropTypes.bool,
  updatePaymentModeLoading: PropTypes.bool,
  createPaymentMode: PropTypes.func,
  updatePaymentMode: PropTypes.func,
  callback: PropTypes.func,
  selectedPaymentMode: PropTypes.any,
  user: PropTypes.any,

};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PaymentModeForm));
